import { render, staticRenderFns } from "./lt-subtask-create-modal.vue?vue&type=template&id=035f7cce&scoped=true&"
import script from "./lt-subtask-create-modal.vue?vue&type=script&lang=js&"
export * from "./lt-subtask-create-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035f7cce",
  null
  
)

export default component.exports